import { defineComponent } from 'vue';
import BaseSocials from '../../mixins/BaseSocial/BaseSocial.js';
import getSerialisedParams from '../../utils/getSerialisedParams.js';

/**
 * Hey!
 *
 * SDouban component used for Douban social network
 * @link https://www.douban.com
 * @example https://accounts.douban.com/passport/login?redir=https%3A//www.douban.com/share/service%3Fname%3D%26href%3D%26image%3D%26updated%3D%26bm%3D%26name%3DTitle%26text%3DText%26comment%3Dhttps%253A%252F%252Fgithub.com%252F%26href%3Dhttps%253A%252F%252Fgithub.com%252F
 */
/**
 * Share parameters for link
 * @link https://blog.duncanworthy.me/misc/how-to-add-chinese-social-media-sharing-links-on-wordpress/comment-page-1/
 */

var SDouban = /* #__PURE__ */defineComponent({
  name: 'SDouban',
  mixins: [BaseSocials('Douban', {
    width: 1100,
    height: 450
  })],
  computed: {
    networkURL: function networkURL() {
      var BASE_URL = 'http://www.douban.com/recommend/';
      var shareOptions = this.shareOptions;
      var title = shareOptions.title,
          url = shareOptions.url;
      var serialisedParams = getSerialisedParams({
        url: url,
        title: title
      });
      return "".concat(BASE_URL).concat(serialisedParams);
    }
  },
  render: function render() {
    return this.generateComponent(this.networkURL);
  }
});

export default SDouban;
